// extracted by mini-css-extract-plugin
module.exports = {"root":"SetPasswdForm_root__1QI9Q","label":"SetPasswdForm_label__37CaK"};